// Builds a human-friendly, date-prefixed filename for exported hikes / recordings / planned trails,
// e.g. "2024-06-28 Wicklow Way.gpx".
//
// The date is yyyy-MM-dd (ISO 8601, local): year-first so it sorts chronologically in a file browser
// AND reads unambiguously for both European and American users (it sidesteps the dd/MM vs MM/dd clash).

export function formatExportDate(date: Date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// Keep the readable name (spaces, casing) but strip characters that are reserved on common
// filesystems, collapse whitespace, and fall back to "Hiiker" when there's nothing usable.
export function sanitizeExportName(name?: string | null): string {
  const cleaned = (name ?? "")
    .toString()
    .replace(/[/\\:*?"<>|]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return cleaned || "Hiiker";
}

export function buildExportFileName(
  name: string | null | undefined,
  extension: string,
  options: { date?: Date; suffix?: string } = {}
): string {
  const datePrefix = formatExportDate(options.date ?? new Date());
  const suffix = options.suffix ?? "";
  return `${datePrefix} ${sanitizeExportName(name)}${suffix}.${extension}`;
}
